<template>
  <div :class="computedClass" @drop.prevent="filesDropped" @dragenter="overDropzone = true" @dragleave="overDropzone = false">
    <div class="text-center" :class="overDropzone ? 'pointer-events-none' : ''">
      <p v-if="description" class="mb-4">{{ description }}</p>
      <i class="far fa-arrow-alt-circle-up fa-4x mb-6"></i>
      <h3 class="mb-6" v-if="draggingFiles">Drop files within this area to upload</h3>
      <h3 class="mb-6" v-else>Drag files to upload, or</h3>

      <div class="flex flex-wrap -mx-2">
        <div class="w-full px-2 text-center">
          <label class="inline-block bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow cursor-pointer" @click.stop>
            <i class="fas fa-folder-open"></i> Choose Files
            <input type="file" class="hidden" @change="manualFilesSelected" :accept="accept" multiple/>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    containerClass: {
      default: 'border-dashed border-2 border-grey-light p-12'
    },
    hintClass: {
      default: 'border-solid border-2 border-yellow-dark p-12'
    },
    hoverClass: {
      default: 'border-solid border-2 border-green-dark bg-green-lightest p-12'
    },
    accept: {
      default: '*'
    },
    description: {
      default: null
    }
  },
  data () {
    return {
      draggingFiles: false,
      overDropzone: false
    }
  },
  created () {
    document.addEventListener('dragover', this.dragAndDropStart)
    document.addEventListener('dragleave', this.dragAndDropEnd)
    document.addEventListener('drop', this.dragAndDropEnd)
  },
  beforeDestroy () {
    document.removeEventListener('dragover', this.dragAndDropStart)
    document.removeEventListener('dragleave', this.dragAndDropEnd)
    document.removeEventListener('drop', this.dragAndDropEnd)
  },
  computed: {
    computedClass () {
      if (this.overDropzone) {
        return this.hoverClass
      }
      if (this.draggingFiles) {
        return this.hintClass
      }
      return this.containerClass
    }
  },
  methods: {
    dragAndDropStart (e) {
      e.preventDefault()
      this.draggingFiles = true
    },
    dragAndDropEnd (e) {
      e.preventDefault()
      this.draggingFiles = false
    },
    filesDropped (e) {
      this.draggingFiles = false
      this.overDropzone = false
      let files = []

      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          if (e.dataTransfer.items[i].kind !== 'file') {
            continue
          }

          files.push(e.dataTransfer.items[i].getAsFile())
        }
      } else {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          files.push(e.dataTransfer.files[i])
        }
      }

      if (files.length) {
        this.$emit('change', files)
      }
    },
    manualFilesSelected (e) {
      this.$emit('change', e.target.files)
    }
  }
}
</script>
